import { useEffect, useState } from "react";
import {
  Alert,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Stack,
  TextField,
  Typography,
} from "@mui/material";
import { createDimensionOption, updateDimensionOption } from "../api/variantDimensions";

function VariantOptionModal({ dimensionId, data, onClose, onSaved }) {
  const [label, setLabel] = useState("");
  const [code, setCode] = useState("");
  const [sortOrder, setSortOrder] = useState("0");
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState("");

  useEffect(() => {
    if (data) {
      setLabel(data.label || "");
      setCode(data.code || "");
      setSortOrder(String(data.sort_order ?? 0));
    } else {
      setLabel("");
      setCode("");
      setSortOrder("0");
    }
  }, [data]);

  async function save() {
    setError("");
    const l = String(label || "").trim();
    if (!l) {
      setError("Label zorunlu.");
      return;
    }

    const payload = {
      label: l,
      code: String(code || "").trim() || null,
      sort_order: Number(sortOrder || 0),
    };

    const req = data
      ? updateDimensionOption(dimensionId, data.id, payload)
      : createDimensionOption(dimensionId, payload);

    setSaving(true);
    try {
      await req;
      await onSaved?.();
      onClose?.();
    } catch (err) {
      console.error("OPTION SAVE ERROR", err);
      const status = err?.response?.status;
      const dataObj = err?.response?.data;
      const message =
        dataObj?.error?.message ||
        dataObj?.message ||
        (typeof dataObj === "string" ? dataObj : null) ||
        err?.message ||
        null;
      setError(`Kaydedilemedi${status ? ` (HTTP ${status})` : ""}${message ? `: ${message}` : ""}`);
    } finally {
      setSaving(false);
    }
  }

  return (
    <Dialog open onClose={saving ? undefined : onClose} maxWidth="sm" fullWidth>
      <DialogTitle sx={{ pb: 1 }}>
        <Typography variant="h6" sx={{ fontWeight: 800 }}>
          {data ? "Seçenek Düzenle" : "Yeni Seçenek"}
        </Typography>
        <Typography variant="body2" color="text.secondary" sx={{ mt: 0.5 }}>
          Seçilen anahtar için seçenek tanımlayın.
        </Typography>
      </DialogTitle>

      <DialogContent dividers>
        <Stack spacing={2}>
          {error ? <Alert severity="error">{error}</Alert> : null}
          <TextField
            label="Label (örn: Kırmızı)"
            value={label}
            onChange={(e) => setLabel(e.target.value)}
            required
            disabled={saving}
          />
          <TextField
            label="Kod (opsiyonel)"
            value={code}
            onChange={(e) => setCode(e.target.value)}
            disabled={saving}
          />
          <TextField
            label="Sıra (0..)"
            type="number"
            value={sortOrder}
            onChange={(e) => setSortOrder(e.target.value)}
            disabled={saving}
          />
        </Stack>
      </DialogContent>

      <DialogActions sx={{ px: 3, py: 2 }}>
        <Button onClick={onClose} color="inherit" disabled={saving}>
          İptal
        </Button>
        <Button onClick={save} variant="contained" disabled={saving}>
          {saving ? "Kaydediliyor..." : "Kaydet"}
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default VariantOptionModal;

